<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addCard"
          >新建储值卡</el-button
        >
        <el-button
          type="text"
          size="small"
          style="font-size: 14px; margin-left: 30px"
          @click="getQrcode"
          >储值卡二维码<i
            class="hmicon icon-erweima"
            style="margin-left: 5px"
          ></i
        ></el-button>
      </div>
      <div>
        <el-select
          size="small"
          clearable
          placeholder="审核状态"
          v-model="searchCondition.auditStatus"
          class="mr10"
        >
          <el-option label="待审核" value="wait"></el-option>
          <el-option label="已通过" value="agree"></el-option>
          <el-option label="已驳回" value="refuse"></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="上架状态"
          v-model="searchCondition.salesState"
          class="mr10"
        >
          <el-option label="上线" value="up"></el-option>
          <el-option label="下线" value="down"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="searchCondition.cardName"
          placeholder="请输入储值卡名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditStatus"
          label="审核状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus === 'wait'" class="blue">
              待审核
            </div>
            <div v-if="scope.row.auditStatus === 'agree'" class="success">
              已通过
            </div>
            <div v-if="scope.row.auditStatus === 'refuse'" class="danger">
              已驳回
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardName"
          label="储值卡名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardBgp"
          label="卡样"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width:100px; height:40px"
                :src="scope.row.cardBgp"
                :preview-src-list="[scope.row.cardBgp]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="可售门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardDenomination"
          label="储值卡面额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardDenomination }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardSalePrice"
          label="储值卡售价"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardSalePrice }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="上架状态"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.salesState === 'down' ? 'danger' : 'success'"
            >
              {{ scope.row.salesState === "down" ? "下线" : "上线" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStatus"
          label="卡状态"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.cardStatus === 'normal' ? 'success' : 'danger'"
            >
              {{ scope.row.cardStatus === "normal" ? "正常" : "作废" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="审核备注"
        >
        </el-table-column>
        <el-table-column
          width="220"
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                v-if="scope.row.auditStatus === 'refuse'"
                type="text"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >详情</el-button
              >
              <!-- <el-button
                size="small"
                type="text"
                :class="scope.row.salesState === 'down' ? 'success' : 'danger'"
              >
                {{
                  scope.row.salesState === "down" ? "上线" : "下线"
                }}</el-button
              > -->
              <el-button
                size="small"
                type="text"
                @click="handleCopy(scope.row)"
                v-if="scope.row.cardStatus === 'normal'"
                >复制卡链接</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.cardStatus === 'normal'"
                @click="toAc(scope.row)"
                >生成激活码</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="invalid(scope.row)"
                v-if="
                  scope.row.cardStatus === 'normal' &&
                    scope.row.auditStatus === 'agree'
                "
                >作废</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div v-if="type === 'add' || type === 'edit'">
        <div slot="header">
          <hm-step
            :steps="steps"
            :step="step"
            :disabledFirst="disabledFirst"
            disabledNext
          ></hm-step>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <div v-if="step === 1">
            <el-form-item label="绑定商品" prop="wxshopSpuName">
              <el-input
                size="small"
                class="mr10 ipt"
                style="width:270px"
                :show-message="showGoodsSn"
                v-model.trim="ruleForm.cardName"
                placeholder="请选择绑定权益商品（虚拟商品）"
                @click.native="selectGood"
                readonly
              ></el-input>
            </el-form-item>
            <div
              class="flex flex-wrap"
              style="font-size:15px;color:#000;font-weight:700;"
            >
              <div style="width:100px;textAlign:right;">储值卡编辑：</div>
              储值卡名称、售价等相关信息为绑定商品时直接带入的商品信息，如果修改该信息则会直接修改商品信息。
            </div>
            <el-form-item label="储值卡名称" prop="cardName">
              <el-input
                type="text"
                maxlength="30"
                v-model.trim="ruleForm.cardName"
                clearable
                placeholder="请输入储值卡名称"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="储值卡售价" prop="cardSalePrice">
              <el-input
                disabled
                type="text"
                @mousewheel.prevent.native
                v-model.trim="ruleForm.cardSalePrice"
                @input="filterGt0OrFixed2('cardSalePrice')"
                clearable
                placeholder="请输入储值卡售价"
                maxlength="10"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="发售数量" prop="stockNum">
              <el-input
                type="text"
                disabled
                maxlength="30"
                @mousewheel.prevent.native
                v-model.trim="ruleForm.stockNum"
                @input="filterGt0OrFixed0('stockNum')"
                clearable
                placeholder="请输入发售数量"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="卡面值" prop="cardDenomination">
              <el-input
                type="text"
                maxlength="10"
                @mousewheel.prevent.native
                v-model.trim="ruleForm.cardDenomination"
                @input="filterGt0OrFixed2('cardDenomination')"
                clearable
                placeholder="请输入储值卡面值"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="卡样式" prop="cardBgp">
              <!-- <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  v-if="!ruleForm.cardBgp"
                  @click="show = true"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传卡背景</span>
                </div>
                <div v-if="ruleForm.cardBgp" class="mr10 flex item-end priview">
                  <img :src="ruleForm.cardBgp" alt="logo" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="flex flex-column flex-end">
                  <div class="tips">建议图片尺寸为690x254px(最多上传一张）</div>
                </div>
              </div> -->
              <el-upload
                class="upload flex"
                ref="upload"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :on-remove="handleRemove"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
              >
                <div v-if="ruleForm.cardBgp" class="mr10 flex item-end priview">
                  <img :src="ruleForm.cardBgp" alt="logo" />
                  <!-- <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                      >删除</el-button
                    >
                  </div> -->
                </div>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.图片尺寸254*690 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="是否允许转赠" prop="allowGift">
              <el-switch
                      v-model="ruleForm.allowGift"
                      active-text="开启"
                      inactive-text="关闭"
                      active-value="yes"
                      inactive-value="no">
              </el-switch>
            </el-form-item>
          </div>
          <div v-if="step === 2">
            <el-form-item label="卡有效期" prop="validMode">
              <el-radio-group v-model="ruleForm.validMode" size="small">
                <el-radio label="now">即买即用</el-radio>
                <el-radio label="range">限时使用 </el-radio>
              </el-radio-group>
              <div>
                <div v-if="ruleForm.validMode === 'now'">
                  购买后
                  <el-input
                    size="small"
                    @input="filterGt0OrFixed0('validDuration')"
                    @mousewheel.prevent.native
                    clearable
                    style="width: 80px"
                    class="mr10"
                    type="text"
                    v-model.trim="ruleForm.validDuration"
                  ></el-input>
                  <span>个月过期。</span>
                </div>

                <el-date-picker
                  v-else
                  :default-time="['00:00:00', '23:59:59']"
                  class="mr10"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="ruleForm.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="请选择开始时间"
                  end-placeholder="请选择结束时间"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="商品限制" prop="goodsLimitMode">
              <el-radio-group
                @change="goodsLimitModeChange"
                v-model="ruleForm.goodsLimitMode"
                size="small"
              >
                <el-radio label="notLimit">不限商品</el-radio>
                <el-radio label="limit">指定使用</el-radio>
              </el-radio-group>
              <hm-card-transfer
                v-show="ruleForm.goodsLimitMode === 'limit'"
                :queryIsUsed="false"
                showUseable
                ref="ruleTransfer"
                showAttribute
                :leftOption="leftRules"
              ></hm-card-transfer>
            </el-form-item>
          </div>
          <div v-if="step === 3">
            <ul class="info-list">
              <li class="mb20">
                <div class="title">
                  基本规则
                </div>
                <div class="modal-table mb20">
                  <div class="table-header flex">
                    <!-- <div class="flex-1">匹配信息</div> -->
                    <div class="flex-1">储值卡名称</div>
                    <div class="flex-1">卡样式</div>
                    <div class="flex-1">储值卡售价</div>
                    <div class="flex-1">发售数量</div>
                    <div class="flex-1">储值卡面值</div>
                  </div>
                  <div class="table-body flex item-center">
                    <!-- <div class="flex-1">
                      {{}}
                    </div> -->
                    <div class="flex-1">
                      {{ ruleForm.cardName }}
                    </div>
                    <div class="flex-1">
                      <el-image
                        style="width:100px; height:40px"
                        :src="ruleForm.cardBgp"
                        :preview-src-list="[ruleForm.cardBgp]"
                      >
                      </el-image>
                    </div>
                    <div class="flex-1">
                      <span class="primary">
                        {{ ruleForm.cardSalePrice }}元
                      </span>
                    </div>
                    <div class="flex-1">
                      {{ ruleForm.stockNum }}
                    </div>
                    <div class="flex-1">
                      <span class="primary">
                        {{ ruleForm.cardDenomination }}元
                      </span>
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb20">
                <div class="title">
                  使用规则
                </div>
                <div style="margin:10px 0;color:#222">
                  <div>
                    使用时段:
                    <span v-if="ruleForm.validMode === 'now'"
                      >即买即用,购买后{{
                        ruleForm.validDuration
                      }}个月过期。</span
                    >
                    <span v-if="ruleForm.validMode === 'range'"
                      >限时使用,{{ ruleForm.validStartTime }}至{{
                        ruleForm.validEndTime
                      }}</span
                    >
                  </div>
                </div>
                <div style="marginBottom:5px;color:#222">
                  商品限制
                </div>
                <el-table
                  v-if="prepayGoodsList.length"
                  stripe
                  ref="brandTable"
                  class="mb20 modal-table"
                  :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
                  :data="prepayGoodsList"
                  style="width: 100%"
                  id="table"
                  size="small"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrId"
                    label="商品Id"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrValue"
                    label="商品名称"
                  ></el-table-column>
                  <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrType"
                    label="类型"
                  ></el-table-column> -->
                </el-table>
                <div v-else>
                  不限商品
                </div>
              </li>
            </ul>
          </div>
        </el-form>

        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="step--" size="small" type="info" v-if="step !== 1"
            >上一步</el-button
          >
          <el-button @click="submitForm('ruleForm')" size="small" type="primary"
            >{{ step === 3 ? "保存" : "下一步" }}
          </el-button>

          <!-- <el-button @click="dialogVisible = false" size="small">关闭</el-button> -->
        </span>
      </div>
      <div v-if="type === 'details'">
        <ul class="info-list">
          <li class="mb20">
            <div class="title">
              基本规则
            </div>
            <div class="modal-table mb20">
              <div class="table-header flex">
                <!-- <div class="flex-1">匹配信息</div> -->
                <div class="flex-1">储值卡名称</div>
                <div class="flex-1">卡样式</div>
                <div class="flex-1">储值卡售价</div>
                <div class="flex-1">发售数量</div>
                <div class="flex-1">储值卡面值</div>
              </div>
              <div class="table-body flex item-center">
                <!-- <div class="flex-1">
                      {{}}
                    </div> -->
                <div class="flex-1">
                  {{ details.cardName }}
                </div>
                <div class="flex-1">
                  <el-image
                    style="width:100px; height:40px"
                    :src="details.cardBgp"
                    :preview-src-list="[details.cardBgp]"
                  >
                  </el-image>
                </div>
                <div class="flex-1">
                  <span class="primary"> {{ details.cardSalePrice }}元 </span>
                </div>
                <div class="flex-1">
                  {{ details.stockNum }}
                </div>
                <div class="flex-1">
                  <span class="primary">
                    {{ details.cardDenomination }}元
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              绑定商品
            </div>
            <div class="modal-table mb20">
              <div class="table-header flex">
                <div class="flex-1">商品名称</div>
                <div class="flex-1">商品主图</div>
                <div class="flex-1">商品货号</div>
              </div>
              <div class="table-body flex item-center">
                <div class="flex-1">
                  {{ details.bindGoodsInfo.wxshopSpuName }}
                </div>
                <div class="flex-1">
                  <el-image
                    style="width:100px; height:40px"
                    :src="details.bindGoodsInfo.spuMainPic"
                    :preview-src-list="[details.bindGoodsInfo.spuMainPic]"
                  >
                  </el-image>
                </div>

                <div class="flex-1">
                  {{ details.bindGoodsInfo.goodsSn }}
                </div>
              </div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              使用规则
            </div>
            <div style="margin:10px 0;color:#222">
              <div>
                使用时段:
                <span v-if="details.validMode === 'now'"
                  >即买即用,购买后{{ details.validDuration }}个月过期。</span
                >
                <span v-if="details.validMode === 'range'"
                  >限时使用,{{ details.validStartTime }}至{{
                    details.validEndTime
                  }}</span
                >
              </div>
            </div>
            <div style="marginBottom:5px;color:#222">
              商品限制
            </div>
            <el-table
              v-if="details.prepayGoodsList.length"
              stripe
              ref="brandTable"
              class="mb20 modal-table"
              :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
              :data="details.prepayGoodsList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrId"
                label="商品Id"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrValue"
                label="商品名称"
              ></el-table-column>
              <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrType"
                    label="类型"
                  ></el-table-column> -->
            </el-table>
            <div v-else>
              不限商品
            </div>
            <div class="mt20" style="marginBottom:5px;color:#222">
              是否允许转赠
            </div>
            <el-switch
              v-model="details.allowGift"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
              disabled
              >
            </el-switch>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small" type="info"
            >取 消</el-button
          >

          <!-- <el-button @click="dialogVisible = false" size="small">关闭</el-button> -->
        </span>
      </div>
    </el-dialog>
    <my-upload
      field="file"
      ref="upload"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      noCircle
      noSquare
      :noRotate="false"
      :width="254"
      :height="690"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <el-dialog
      custom-class="import-dialog"
      title="添加商品"
      width="70%"
      :visible.sync="dialogVisibleGoods"
      :close-on-click-modal="false"
    >
      <div class="p20">
        <div class="table-panel flex flex-between">
          <div class="flex text-right  flex-end">
            <el-input
              clearable
              style="width:200px;"
              v-model.trim="searchDialogCondition.keyWords"
              placeholder="请输入货号/条码/商品名称"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-input
              clearable
              v-model.trim="searchDialogCondition.minPrice"
              placeholder="最低零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-input
              clearable
              v-model.trim="searchDialogCondition.maxPrice"
              placeholder="最高零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchGoods"
              >查询</el-button
            >
            <el-button
              type="info"
              size="small"
              @click="searchDialogCondition = {}"
              >重置</el-button
            >
          </div>
        </div>
        <div class="table mb20">
          <div class="tips mb20">提示：点击表格行即可选择</div>
          <el-table
            stripe
            border
            ref="brandTable"
            @current-change="handleCurrentChange"
            highlight-current-row
            :data="virtualGoods.records"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index => index + (currentVirtualPage - 1) * pageVirtualSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSnAndBarcode"
              show-overflow-tooltip
              label="规格"
            >
              <template slot-scope="scope">
                <div>
                  <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                  <span>{{ scope.row.specIdGroupName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="类别"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="价格信息"
            >
              <template slot-scope="scope">
                <div>
                  <span>零售价：</span>
                  <span class="rose">{{ scope.row.wxshopPrice }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="virtualGoods.total"
            @current-change="pagingVirtual"
            @size-change="handleSizeVirtualChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentVirtualPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="dialogVisibleGoods = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 列表生成激活码弹框 -->
    <el-dialog
      title="生成激活码"
      width="60%"
      :visible.sync="dialogVisibleActivationCode"
      :close-on-click-modal="false"
    >
      <div>
        <div class="mt10">
          <el-button
            size="small"
            type="primary"
            @click="dialogVisibleCreateActivationCode = true"
            >生成激活码</el-button
          >
        </div>
        <div class="mt20">
          <el-table
            :data="activationCodeList"
            border
            stripe
            :height="500"
            size="small"
            style="width: 100%"
          >
            <template slot="empty">
              <div class="empty" style="margin-top: 20px">
                <i
                  class="hmicon icon-a-zanwushuju2x"
                  style="font-size: 38px"
                ></i>
                <p class="empty_tex">暂无数据</p>
              </div>
            </template>
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="55"
              :index="index => index + (acCurrentPage - 1) * acPageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="tagName"
              label="标签"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="生成时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="preNum"
              label="生成数量"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="randomNum"
              label="位数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="prefix"
              label="前缀"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="suffix"
              label="后缀"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeAddress"
              label="操作"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="toAcDetail(scope.row)"
                    >激活码</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="acTotal"
              @current-change="acPaging"
              @size-change="acHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="acCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div class="btn-wrapper mt20 flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="dialogVisibleActivationCode = false"
            >返 回</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 激活码弹框 -->
    <el-dialog
      title="激活码"
      width="60%"
      :append-to-body="true"
      :visible.sync="dialogVisibleCatActivationCode"
      :close-on-click-modal="false"
    >
      <div>
        <div class="mt10 flex flex-end item-center">
          <el-select
            v-model="activationCodeQuery.activateState"
            style="width: 160px"
            size="small"
            class="mr10"
            clearable
            placeholder="请选择状态"
          >
            <el-option :label="'已激活'" :value="'yes'"> </el-option>
            <el-option :label="'未激活'" :value="'no'"> </el-option>
          </el-select>
          <el-input
            placeholder="请输入手机号"
            style="width: 160px"
            size="small"
            class="mr10"
            v-model="activationCodeQuery.memberMobile"
            clearable
          >
          </el-input>
          <el-button size="small" type="primary" @click="acDetailPaging(1)"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            class="ml10"
            :loading="isOutputing"
            @click="output"
            >导出</el-button
          >
        </div>
        <div class="mt20">
          <el-table
            :data="acDetailTivationCodeList"
            border
            stripe
            :height="500"
            size="small"
            style="width: 100%"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="55"
              :index="
                index =>
                  index + (acDetailCurrentPage - 1) * acDetailPageSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="activateCode"
              label="激活码"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="activateState"
              label="状态"
            >
              <template slot-scope="scope">
                <span
                  style="color: #2FC348"
                  v-if="scope.row.activateState == 'yes'"
                  >已激活</span
                >
                <span style="color:#FF0000;" v-else>未激活</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="activateTime"
              label="激活时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberMobile"
              label="激活人手机号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="激活人"
            >
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="acDetailTotal"
              @current-change="acDetailPaging"
              @size-change="acDetailHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="acDetailCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div class="btn-wrapper mt20 flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="dialogVisibleCatActivationCode = false"
            >返 回</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 生成激活码弹框 -->
    <el-dialog
      title="生成激活码"
      width="700px"
      :append-to-body="true"
      :visible.sync="dialogVisibleCreateActivationCode"
      :close-on-click-modal="false"
    >
      <div>
        <div>
          <el-form
            :model="activationCodeRuleForm"
            :rules="activationCodeRules"
            ref="activationCodeRuleForm"
            label-width="150px"
          >
            <el-form-item label="标签" prop="tagName">
              <el-input
                v-model="activationCodeRuleForm.tagName"
                size="small"
                style="width: 280px"
                placeholder="请输入激活码标签"
              ></el-input>
            </el-form-item>
            <el-form-item label="生成激活码数量" prop="preNum">
              <el-input
                v-model="activationCodeRuleForm.preNum"
                type="number"
                size="small"
                class="mr10"
                style="width: 180px"
                placeholder="请输入激活码数量"
              ></el-input
              >个
              <div style="font-size: 12px; color: #666666">
                大于0的整数，一次不要超过500个
              </div>
            </el-form-item>
            <el-form-item label="位数(不包含前后缀)" prop="randomNum">
              <el-input
                v-model="activationCodeRuleForm.randomNum"
                type="number"
                size="small"
                class="mr10"
                style="width: 180px"
                placeholder="请输入激活码位数"
              ></el-input>
            </el-form-item>
            <el-form-item label="前缀" prop="name">
              <el-input
                v-model="activationCodeRuleForm.prefix"
                size="small"
                class="mr10"
                style="width: 180px"
                placeholder="请输入激活码前缀"
              ></el-input>
            </el-form-item>
            <el-form-item label="后缀" prop="name">
              <el-input
                v-model="activationCodeRuleForm.suffix"
                size="small"
                class="mr10"
                style="width: 180px"
                placeholder="请输入激活码后缀"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-wrapper mt20 flex flex-center">
          <el-button size="small" type="primary" @click="createActivationCode"
            >确 定</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="dialogVisibleCreateActivationCode = false"
            >返 回</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="二维码"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activationCodeQrcode" alt="二维码" />
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmCardTransfer from "@/components/HmCardTransfer";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";
export default {
  components: { HmStep, myUpload, HmCardTransfer },
  data() {
    const limitGoodsFunc = (rule, val, callback) => {
      if (val === "limit") {
        if (this.prepayGoodsList.length === 0) {
          return callback(new Error("请选择指定商品"));
        } else callback();
      }
      callback();
    };
    const validModeFunc = (rule, val, callback) => {
      if (val === "now") {
        if (this.ruleForm.validDuration === "") {
          return callback(new Error("请填写卡有效期"));
        } else callback();
      } else {
        if (this.ruleForm.date.length === 0) {
          return callback(new Error("请填写卡有效期"));
        } else callback();
      }
      callback();
    };
    const validNumberFunc = (rule, val, callback) => {
      let reg = /^[+]{0,1}(\d+)$/g;
      if (!reg.test(val)) {
        callback(new Error("请输入0及0以上的整数"));
      } else {
        callback();
      }
    };
    const validPreNumFunc = (rule, val, callback) => {
      if (val > 500) {
        callback(new Error("一次最大只能生成500个"));
      } else {
        callback();
      }
    };
    const validRandomNumFunc = (rule, val, callback) => {
      if (val < 8) {
        callback(new Error("位数最小为8位"));
      } else if (val > 20) {
        callback(new Error("位数最大为20位"));
      } else {
        callback();
      }
    };
    return {
      type: "",
      leftRules: [],
      showGoodsSn: true,
      show: false,
      ruleForm: {
        wxshopSpuName: "",
        cardName: "",
        cardSalePrice: "",
        stockNum: "",
        cardDenomination: "",
        cardBgp: "https://imgcdn.hemiao100.com/ThemePictures/cardImg.png",
        validMode: "now",
        validDuration: "",
        date: [],
        validStartTime: "",
        validEndTime: "",
        goodsLimitMode: "notLimit",
        allowGift: "yes",
      },
      rules: {
        cardName: {
          required: true,
          message: "请输入储值卡名称",
          trigger: "blur"
        },
        cardSalePrice: {
          required: true,
          message: "请输入储值卡售价",
          trigger: "blur"
        },
        stockNum: {
          required: true,
          message: "请输入发售数量",
          trigger: "blur"
        },
        cardDenomination: {
          required: true,
          message: "请输入储值卡面值",
          trigger: "blur"
        },
        cardBgp: {
          required: true,
          message: "请添加卡背景",
          trigger: "blur"
        },
        validMode: [
          {
            required: true,
            validator: validModeFunc,
            trigger: "blur"
          }
        ],
        goodsLimitMode: [
          {
            required: true,
            validator: limitGoodsFunc,
            trigger: "blur"
          }
        ]
      },
      disabledFirst: false,
      step: 1,
      steps: [
        {
          name: "添加基本信息"
        },
        {
          name: "使用规则"
        },
        {
          name: "卡预览"
        }
      ],
      title: "",
      dialogVisible: false,
      dialogVisibleGoods: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      searchCondition: {},
      searchDialogCondition: {},
      currentVirtualPage: 1,
      pageVirtualSize: 10,
      currentRow: {},
      prepayGoodsList: [],
      details: {
        prepayGoodsList: [],
        bindGoodsInfo: {}
      },
      isSaving: false,
      row: {},
      successGoods: false,
      dialogVisibleActivationCode: false,
      activationCodeList: [],
      dialogVisibleCatActivationCode: false,
      activationCodeQuery: {},
      activationCodeRuleForm: {},
      activationCodeRules: {
        tagName: [{ required: true, message: "请输入标签", trigger: "blur" }],
        preNum: [
          { required: true, message: "请输入生成激活码数量", trigger: "blur" },
          { trigger: "blur", validator: validNumberFunc },
          { trigger: "blur", validator: validPreNumFunc }
        ],
        randomNum: [
          { required: true, message: "请输入位数", trigger: "blur" },
          { trigger: "blur", validator: validNumberFunc },
          { trigger: "blur", validator: validRandomNumFunc }
        ]
      },
      dialogVisibleCreateActivationCode: false,
      acRow: {},
      acTotal: 0,
      acCurrentPage: 1,
      acPageSize: 10,
      acDetailTotal: 0,
      acDetailCurrentPage: 1,
      acDetailPageSize: 10,
      acDetailTivationCodeList: [],
      qrcodeDialogVisible: false,
      activationCodeQrcode: "",
      isOutputing: false
    };
  },
  computed: mapGetters(["virtualGoods"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllDeatilActivationCodeList().then(res => {
          console.log("进来了");
          console.log("res", res);
          const list = res.result.records;

          list.forEach(v => {
            v.activateState = v.activateState == "yes" ? "已激活" : "未激活";
          });

          const tHeader = [
            "激活码",
            "状态",
            "激活时间",
            "激活人手机号",
            "激活人"
          ];
          const filterVal = [
            "activateCode",
            "activateState",
            "activateTime",
            "memberMobile",
            "memberName"
          ];
          const data = this.formatJson(filterVal, list);
          exportJsonToExcel(tHeader, data, "激活码");
          this.isOutputing = false;
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    //获取二维码
    async getQrcode() {
      let path = "article/valueCardActivation";
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path
      });
      this.qrcodeDialogVisible = true;
      this.activationCodeQrcode = result;
    },
    acDetailPaging(page) {
      this.acDetailCurrentPage = page;
      this.queryDeatilActivationCodeList();
    },
    acDetailHandleSizeChange(size) {
      this.acDetailCurrentPage = 1;
      this.acDetailPageSize = size;
      this.queryDeatilActivationCodeList();
    },
    toAcDetail(row) {
      this.acRow = row;
      this.queryDeatilActivationCodeList();
      this.dialogVisibleCatActivationCode = true;
    },
    queryAllDeatilActivationCodeList() {
      return this.$store.dispatch("queryDeatilActivationCodeList", {
        activateId: this.acRow.id,
        pageNo: 1,
        pageSize: 9999
      });
    },
    //查询激活码详情列表
    async queryDeatilActivationCodeList() {
      let params = {
        activateId: this.acRow.id,
        pageNo: this.acDetailCurrentPage,
        pageSize: this.acDetailPageSize
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.activationCodeQuery)
      );
      Object.assign(params, searchDialogCondition);
      const { result } = await this.$store.dispatch(
        "queryDeatilActivationCodeList",
        params
      );
      const { records, total } = result;
      this.acDetailTivationCodeList = records;
      this.acDetailTotal = total;
    },
    acPaging(page) {
      this.acCurrentPage = page;
      this.queryActivationCodeList();
    },
    acHandleSizeChange(size) {
      this.acCurrentPage = 1;
      this.acPageSize = size;
      this.queryActivationCodeList();
    },
    toAc(row) {
      this.row = row;
      this.queryActivationCodeList();
      this.dialogVisibleActivationCode = true;
    },
    //查询激活码列表
    async queryActivationCodeList() {
      let params = {
        cardId: this.row.cardId,
        pageNo: this.acCurrentPage,
        pageSize: this.acPageSize
      };
      const { result } = await this.$store.dispatch(
        "queryActivationCodeList",
        params
      );
      const { records, total } = result;
      this.activationCodeList = records;
      this.acTotal = total;
    },
    //生成激活码
    createActivationCode() {
      this.$refs.activationCodeRuleForm.validate(valid => {
        if (valid) {
          let params = this.activationCodeRuleForm;
          params.cardId = this.row.cardId;
          this.$store.dispatch("createCctivatecode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.dialogVisibleCreateActivationCode = false;
              this.queryActivationCodeList();
              this.resetForm();
            }
          });
        }
      });
    },
    resetForm() {
      this.$refs.activationCodeRuleForm.resetFields();
    },
    async validationModleGoods(row) {
      try {
        const { code } = await this.$store.dispatch("validationModleGoods", {
          wxshopSkuId: row.wxshopSkuId
        });
        if (code === "0") {
          this.successGoods = true;
        }
      } catch (error) {
        this.successGoods = false;
      }
    },
    goodsLimitModeChange(val) {
      if (val === "notLimit") {
        this.prepayGoodsList = [];
        this.$refs.ruleTransfer.rightData = [];
      }
    },
    rest() {
      setTimeout(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
      }, 0);
    },
    handleClose() {
      this.dialogVisible = false;
      this.rest();
      this.resetRuleForm();
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    save() {
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        if (this.successGoods) {
          this.dialogVisibleGoods = false;
          this.ruleForm.wxshopSpuName = this.currentRow.wxshopSpuName;
          this.ruleForm.wxshopSkuId = this.currentRow.wxshopSkuId;
          this.ruleForm.cardName = this.currentRow.wxshopSpuName;
          this.ruleForm.cardSalePrice = this.currentRow.wxshopPrice;
          this.ruleForm.stockNum = this.currentRow.stockNum || 0;
        } else {
          this.$message({
            type: "warning",
            message: "设置的储值卡商品已存在!"
          });
        }
      }
    },
    handleSizeVirtualChange(size) {
      this.currentVirtualPage = 1;
      this.pageSize = size;
      this.queryVirtualList();
    },
    pagingVirtual(page) {
      this.currentVirtualPage = page;
      this.queryVirtualList();
    },
    searchGoods() {
      this.currentVirtualPage = 1;
      this.queryVirtualList();
    },
    handleCurrentChange(row) {
      this.currentRow = row;
      this.validationModleGoods(row);
    },
    queryVirtualList() {
      let params = {
        pageSize: this.pageVirtualSize,
        pageNo: this.currentVirtualPage,
        spuType: "virtual"
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      Object.assign(params, searchDialogCondition);
      this.$store.dispatch("virtualGoods", params);
    },
    selectGood() {
      this.dialogVisibleGoods = true;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async submitForm(formName) {
      console.log(111111)
      if (this.step === 2) {
        this.prepayGoodsList = this.$refs.ruleTransfer.rightData;
      }

      const valid = await this.$refs[formName].validate();
      if (valid) {
        if (this.step === 1) {
          this.validationModleGoods(this.ruleForm);
          if (this.successGoods) {
            setTimeout(() => {
              if (this.$refs.ruleTransfer) {
                this.$refs.ruleTransfer.rightData = this.details.prepayGoodsList;
              }
            }, 0);
          }
        }

        this.ruleForm.validStartTime = this.isArray(this.ruleForm.date)
          ? this.ruleForm.date[0]
          : "";
        this.ruleForm.validEndTime = this.isArray(this.ruleForm.date)
          ? this.ruleForm.date[1]
          : "";
        if (this.step === 3) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.prepayGoodsList = this.prepayGoodsList;
          let name = this.type === "add" ? "addPrepayCard" : "editPrepayCard";
          if (this.type === "edit") {
            params.cardId = this.row.cardId;
            params.auditStatus = "wait";
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.$message({
              type: "success",
              message: "操作成功"
            });

            this.resetRuleForm();
            this.dialogVisible = false;
            this.queryList();
          }
        }
        if (this.step < 3) {
          this.step++;
        }
        // this.step < 3 ? this.step++ : this.step;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.cardBgp = "";
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.cardBgp = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    addCard() {
      const { storeCode } = getLoginUser();
       this.$store.dispatch("check", { storeCode:storeCode }).then(res=>{
         if (res.code === "0") {
           this.type = "add";
           this.title = "新建储值卡";
           this.queryVirtualList();
           this.ruleForm.cardBgp =
               "https://imgcdn.hemiao100.com/ThemePictures/cardImg.png";
           this.dialogVisible = true;
         }
       });
    },
    edit(row) {
      this.row = row;
      this.type = "edit";
      this.title = "编辑储值卡";
      this.queryVirtualList();
      this.dialogVisible = true;
      this.$store
        .dispatch("detailPrepayCard", { cardId: row.cardId })
        .then(res => {
          this.details = res.result;
          for (let key in this.details) {
            this.ruleForm[key] = this.details[key];
          }

          // this.ruleForm.wxshopSpuName=this.details[key];
        });
    },
    toDetails(row) {
      this.type = "details";
      this.title = "储值卡详情";
      this.dialogVisible = true;
      this.$store
        .dispatch("detailPrepayCard", { cardId: row.cardId })
        .then(res => {
          this.details = res.result;
          if(!this.details.allowGift){
            this.details.allowGift = "yes";
          }          
        });
    },
    invalid(row) {
      this.$confirm(" 是否确定作废此卡?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          cardId: row.cardId
        };
        this.$store.dispatch("invalidCart", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    handleCopy(row) {
      let data = `pages/product/product.html?wxshopSpuId=${row.wxshopSpuId}`;
      this.copy(data);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryPrepayCardList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    resetRuleForm() {
      setTimeout(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        this.prepayGoodsList = [];
        this.step = 1;
        this.ruleForm.wxshopSpuName = "";
        this.ruleForm.cardName = "";
        this.ruleForm.cardSalePrice = "";
        this.ruleForm.stockNum = "";
        this.ruleForm.cardDenomination = "";
        this.ruleForm.cardBgp = "";
        this.ruleForm.validMode = "now";
        this.ruleForm.validDuration = "";
        this.ruleForm.date = [];
        this.ruleForm.validStartTime = "";
        this.ruleForm.validEndTime = "";
        this.ruleForm.goodsLimitMode = "notLimit";
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.logo {
  width: 80px;
}
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 10px;
    }
  }
}
.empty {
  .empty_tex {
    line-height: 0px;
  }
}
</style>
